import { render } from "./RecommendAdPurchaseView.vue?vue&type=template&id=945b7cde&scoped=true"
import script from "./RecommendAdPurchaseView.vue?vue&type=script&lang=js"
export * from "./RecommendAdPurchaseView.vue?vue&type=script&lang=js"

import "./RecommendAdPurchaseView.vue?vue&type=style&index=0&id=945b7cde&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-945b7cde"]])

export default __exports__